import Hero from '../heroes';
import AttackKeys from '../constants/AttackKeys';

const HeroList = [
  new Hero({
    id: '1',
    name: 'deadbody',
    spriteSheet: '/assets/sprites/dead_body.png',
    strength: 50,
    stamina: 40,
    agility: 80,
    intelligence: 20,
    luck: 20,
    skills: [],
    attackType: AttackKeys.Thrust,
    team: 'A',
  }).serialize(),
  new Hero({
    id: '2',
    name: 'knight',
    spriteSheet: '/assets/sprites/knight.png',
    strength: 50,
    stamina: 40,
    agility: 80,
    intelligence: 20,
    luck: 20,
    skills: [],
    attackType: AttackKeys.Slash,
    team: 'A',
  }).serialize(),
  new Hero({
    id: '3',
    name: 'kingkong',
    spriteSheet: '/assets/sprites/king_kong.png',
    strength: 50,
    stamina: 40,
    agility: 80,
    intelligence: 20,
    luck: 20,
    skills: [],
    attackType: AttackKeys.Slash,
    team: 'A',
  }).serialize(),
  new Hero({
    id: '4',
    name: 'wonderwoman',
    spriteSheet: '/assets/sprites/wonder_woman.png',
    strength: 50,
    stamina: 40,
    agility: 80,
    intelligence: 20,
    luck: 20,
    skills: [],
    attackType: AttackKeys.Slash,
    team: 'B',
  }).serialize(),
  new Hero({
    id: '5',
    name: 'priatezombie',
    spriteSheet: '/assets/sprites/pirate_zombie.png',
    strength: 50,
    stamina: 40,
    agility: 80,
    intelligence: 20,
    luck: 20,
    skills: [],
    attackType: AttackKeys.Thrust,
    team: 'B',
  }).serialize(),
  new Hero({
    id: '6',
    name: 'princejoyce',
    spriteSheet: '/assets/sprites/prince_joyce.png',
    strength: 50,
    stamina: 40,
    agility: 80,
    intelligence: 20,
    luck: 20,
    skills: [],
    attackType: AttackKeys.Slash,
    team: 'B',
  }).serialize(),
];

export default HeroList;
